import { Component, OnInit } from '@angular/core';
import { BsAppLaunchFormService } from '../../services/bs-app-launch-form.service';
import { RadioButtonFormControl } from './radio-button.control';
import { BsAppLaunchFormControlBaseComponent } from '../bs-app-launch-form-control-base.component';

@Component({
  selector: 'app-bs-app-launch-radio-button-control',
  templateUrl: './bs-app-launch-radio-button-control.component.html',
  styleUrls: ['./bs-app-launch-radio-button-control.component.scss']
})
export class BsAppLaunchRadioButtonControlComponent extends BsAppLaunchFormControlBaseComponent<RadioButtonFormControl> implements OnInit {

  formControl: RadioButtonFormControl;

  constructor(bsAppLaunchFormService: BsAppLaunchFormService) {
    super(bsAppLaunchFormService);
  }

  ngOnInit() {
    // Track initial value
    this.formControl.trackValueForFormUpdates();

    this.subs.sink = this.formControl.valueChanges.subscribe(() => {
      this.toggle();
      
      // Check if value changed and emit
      this.checkAndFireFormUpdate();
      // Update tracked value after emitting
      this.formControl.trackValueForFormUpdates();
    });
  }

}
